// TR
export const locale = {
    TRANSLATOR: {
        SELECT: "Dil seçin"
    },
    MENU: {
        NEW: "Yeni",
        ACTIONS: "Eylemler",
        CREATE_POST: "Yeni Gönderi Oluştur",
        PAGES: "Sayfalar",
        FEATURES: "Özellikler",
        APPS: "Uygulamalar",
        DASHBOARD: "Dashboard"
    },
    AUTH: {
        GENERAL: {
            OR: "Veya",
            SUBMIT_BUTTON: "Kaydet",
            NO_ACCOUNT: "Hesabınız Yok Mu?",
            SIGNUP_BUTTON: "Kayıt Ol",
            FORGOT_BUTTON: "Şifrenizi Unuttunuz Mu?",
            BACK_BUTTON: "Geri",
            PRIVACY: "Privacy",
            LEGAL: "Legal",
            CONTACT: "Contact"
        },
        LOGIN: {
            TITLE: "Giriş Hesabı",
            BUTTON: "Giriş"
        },
        FORGOT: {
            TITLE: "Şifrenizi Unuttunuz Mu?",
            DESC: "Şifrenizi sıfırlamak için eposta adresinizi giriniz.",
            SUCCESS: "Şifreniz başarıyla sıfırlanmıştır."
        },
        REGISTER: {
            TITLE: "Kayıt Ol",
            DESC: "Bilgilerinizi girip hsabınızı oluşturunuz.",
            SUCCESS: "Hesabınız başarıyla oluşturuldu."
        },
        INPUT: {
            EMAIL: "Eposta",
            FULLNAME: "İsim",
            PASSWORD: "Şifre",
            CONFIRM_PASSWORD: "Şifre tekrar",
            USERNAME: "Kullanıcı adı"
        },
        VALIDATION: {
            INVALID: "{{name}} is not valid",
            REQUIRED: "{{name}} is required",
            MIN_LENGTH: "{{name}} minimum length is {{min}}",
            AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
            NOT_FOUND: "The requested {{name}} is not found",
            INVALID_LOGIN: "The login detail is incorrect",
            REQUIRED_FIELD: "Required field",
            MIN_LENGTH_FIELD: "Minimum field length:",
            MAX_LENGTH_FIELD: "Maximum field length:",
            INVALID_FIELD: "Field is not valid"
        }
    },
    ECOMMERCE: {
        COMMON: {
            SELECTED_RECORDS_COUNT: "Selected records count: ",
            ALL: "All",
            SUSPENDED: "Suspended",
            ACTIVE: "Active",
            FILTER: "Filter",
            BY_STATUS: "by Status",
            BY_TYPE: "by Type",
            BUSINESS: "Business",
            INDIVIDUAL: "Individual",
            SEARCH: "Search",
            IN_ALL_FIELDS: "in all fields"
        },
        ECOMMERCE: "eCommerce",
        CUSTOMERS: {
            CUSTOMERS: "Customers",
            CUSTOMERS_LIST: "Customers list",
            NEW_CUSTOMER: "New Customer",
            DELETE_CUSTOMER_SIMPLE: {
                TITLE: "Customer Delete",
                DESCRIPTION:
                    "Are you sure to permanently delete this customer?",
                WAIT_DESCRIPTION: "Customer is deleting...",
                MESSAGE: "Customer has been deleted"
            },
            DELETE_CUSTOMER_MULTY: {
                TITLE: "Customers Delete",
                DESCRIPTION:
                    "Are you sure to permanently delete selected customers?",
                WAIT_DESCRIPTION: "Customers are deleting...",
                MESSAGE: "Selected customers have been deleted"
            },
            UPDATE_STATUS: {
                TITLE: "Status has been updated for selected customers",
                MESSAGE:
                    "Selected customers status have successfully been updated"
            },
            EDIT: {
                UPDATE_MESSAGE: "Customer has been updated",
                ADD_MESSAGE: "Customer has been created"
            }
        }
    }
};
